import Vue from 'vue';
import Component from 'vue-class-component';
import { getDpaPdfFromApi } from '@/services/api/api';

@Component
export default class PdfMixin extends Vue {
  async getPdfDpa(dateValidation: string): Promise<void> {
    const response = await getDpaPdfFromApi({ dateDpa: dateValidation });
    if (response && 'data' in response) {
      const pdfBase64 = response.data.pdf;
      const pdfArrayBuffer = Uint8Array.from(atob(pdfBase64), (c) => c.charCodeAt(0));
      const pdfBlob = new Blob([pdfArrayBuffer], { type: 'application/pdf' });
      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(pdfBlob);
      downloadLink.setAttribute('download', 'recap_dpa_jour.pdf');
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } else {
      this.$store.dispatch('notification/add', {
        type: 'error',
        message: 'Un problème est survenu lors de la génération du pdf'
      });
    }
  }
}
